import {LocationPoint} from '@/common/interfaces/location';
import {generateBitMask} from '@/common/helpers/utils/bitMask';

export type LocationField = Exclude<keyof LocationPoint, 'id' | 'titleGc'>;

const locationFieldBits: Record<LocationField, number> = {
	type: 1,
	flags: 1 << 1,
	title: 1 << 2,
	titleLc: 1 << 3,
	description: 1 << 5,
};

export const generateLocationAttributeMask = (fields: LocationField[] = []) => {
	return generateBitMask(fields, locationFieldBits);
};
